import type {Channel,Content} from '../../lib/types';

export function hasPublication(item:Content){
  return item.isPublished ?? !!(item.contentState==='published'||item.state==='published'||item.imported||item.publications?.length||item.publishedAt);
}

export function canTrashDraft(item:Content,channels:Channel[]){
  const ids=item.kind==='article'?[item.resourceId]:(item.variants??[]).map(variant=>variant.resourceId);
  // Unpublishing does not make an article safe to delete. Keep this distinct
  // from the current live state used by the overview and analytics.
  const history=item.hasPublicationHistory||item.publishedAt||item.publications?.length||item.imported;
  return !history&&!hasPublication(item)&&!item.generation&&item.contentState!=='scheduled'&&ids.length>0&&ids.every(id=>channels.some(channel=>channel.resource.id===id&&channel.capabilities?.canWrite));
}
